// angular
import {Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
  standalone: true,
  imports: [TranslateModule],
})
export class ProfileComponent {
  constructor() {}
}
